import { Action, createReducer, on } from '@ngrx/store';
import {
  cleanMaquinas,
  loadedMaquinasError,
  loadedMaquinasSuccess
} from './maquina.actions';
import { IMaquinasState, initialMaquinaState } from './maquina.state';

const reducer = createReducer(
  initialMaquinaState,
  on(loadedMaquinasSuccess, (state, payload) => (
    {
  
    ...state,
    maquinas: payload.maquinas,
    calendario: payload.calendario,
  })),
  on(loadedMaquinasError, (state, payload) => ({
    ...state,
    errors: payload.error,
  })),
  on(cleanMaquinas, () => ({
    ...initialMaquinaState,
  }))
);

export function maquinaReducer(
  state: IMaquinasState = initialMaquinaState,
  action: Action
): IMaquinasState {
  return reducer(state, action);
}
